import { ClientModel } from "../members/client/client.model";
import { ContactModel } from "../contact/contact.model";
import { UserModel } from "../members/user/user.model";
import { RequisitionBaseModel } from "./requisition-base.model";

export class RequisitionModel extends RequisitionBaseModel {
    client: ClientModel = new ClientModel();
    account: ContactModel = new ContactModel();
    processedBy?: UserModel;
    createdBy?: UserModel;    
    additionalInfo?: string;
}